export default class MobileUtils {
  static isMobile(): boolean {
    return this.isAndroid() || this.isIOS();
  }

  static isAndroid(): boolean {
    const ua = navigator.userAgent;

    return /android/i.test(ua);
  }

  static isIOS(): boolean {
    const ua = navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua);
  }
}
